import { type KeyboardLayoutObject } from 'react-simple-keyboard';

export enum KeyboardLayoutName {
  DEFAULT = 'default',
  SHIFT = 'shift', // To enable the shift layout, you must include a KeyboardKey.SHIFT or KeyboardKey.CAPS_LOCK button in your default layout
}

export enum KeyboardKey {
  SHIFT = '{shift}',
  CAPS_LOCK = '{lock}',
  BACKSPACE = '{bksp}',
  ENTER = '{enter}',
  SUBMIT = '{submit}',
  TAB = '{tab}',
  SPACE = '{space}',

  // All the other keys should be a literal of what they represent
}

const TEXT: KeyboardLayoutObject = Object.freeze({
  default: [
    `\` 1 2 3 4 5 6 7 8 9 0 - = ${KeyboardKey.BACKSPACE}`,
    `${KeyboardKey.TAB} q w e r t y u i o p [ ] \\`,
    `${KeyboardKey.CAPS_LOCK} a s d f g h j k l ; ' ${KeyboardKey.ENTER}`,
    `${KeyboardKey.SHIFT} z x c v b n m , . / ${KeyboardKey.SUBMIT}`,
    `${KeyboardKey.SPACE}`,
  ],
  shift: [
    `~ ! @ # $ % ^ & * ( ) _ + ${KeyboardKey.BACKSPACE}`,
    `${KeyboardKey.TAB} Q W E R T Y U I O P { } |`,
    `${KeyboardKey.CAPS_LOCK} A S D F G H J K L : " ${KeyboardKey.ENTER}`,
    `${KeyboardKey.SHIFT} Z X C V B N M < > ? ${KeyboardKey.SUBMIT}`,
    `${KeyboardKey.SPACE}`,
  ],
});

const NUMERIC: KeyboardLayoutObject = Object.freeze({
  default: [
    '1 2 3',
    '4 5 6',
    '7 8 9',
    '. 0 -',
    `${KeyboardKey.BACKSPACE} ${KeyboardKey.SUBMIT}`,
  ],
});

export const KeyboardLayout = Object.freeze({
  TEXT,
  NUMERIC,
});

export const KeyboardDisplay = Object.freeze({
  [KeyboardKey.SHIFT]: 'shift ⇧',
  [KeyboardKey.CAPS_LOCK]: 'caps lock ⇪',
  [KeyboardKey.BACKSPACE]: 'backspace ⌫',
  [KeyboardKey.ENTER]: 'enter ↵',
  [KeyboardKey.SUBMIT]: 'submit ✓',
  [KeyboardKey.TAB]: 'tab ⇥',
  [KeyboardKey.SPACE]: 'space',
});
